"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('@emotion/react');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react3 = require('react'); var _react4 = _interopRequireDefault(_react3);var _jsxruntime = require('react/jsx-runtime');var d=_react.keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
`,g=(e,t)=>e==="circle"?"50%":e==="text"?t.measurements.shape(.75):0,i=(e,t,n)=>e.$height?Number(e.$height)?`${e.$height}px`:e.$height:t==="circle"?n.measurements.spacing(20):t==="text"?n.measurements.spacing(10):"100%",f=(e,t,n)=>t==="circle"?e.$height?i(e,t,n):n.measurements.spacing(20):e.$width?Number(e.$width)?`${e.$width}px`:e.$width:"100%",y=(e,t)=>e.$color?`${e.$color}1c`:t.mode==="dark"?`${t.palette.WHITE}21`:`${t.palette.BLACK}1c`,T=_styled2.default.div`
  height: ${e=>i(e,e.$variant,e.theme)};
  width: ${e=>f(e,e.$variant,e.theme)};
  min-height: ${e=>e.theme.measurements.spacing(4)};
  min-width: ${e=>e.theme.measurements.spacing(6)};
  background: ${e=>y(e,e.theme)};
  animation: ${e=>e.$animation?d:"none"} 1.5s
    ease-in-out 0.5s infinite normal none running;
  border-radius: ${e=>g(e.$variant,e.theme)};
`,S=_react4.default.forwardRef((e,t)=>{let{variant:n,height:r,width:a,className:o,animation:s=!0,ariaLabel:l,dataTestId:m,color:c}=e;return _jsxruntime.jsx.call(void 0, T,{ref:t,$height:r,$width:a,$variant:n,$animation:s,$color:c,"data-testid":m,"aria-label":l,className:`${o||""} aquilla-skeleton skeleton`})}),E= exports.a =S;exports.a = E;
